import forEach from './forEach';
export default function filter(obj, cb) {
    const filteredObject = {};
    forEach(obj, (value, key) => {
        if (cb(value, key)) {
            filteredObject[key] = value;
        }
    });
    return filteredObject;
}
